var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c("v-col", [_c("h1", [_vm._v(_vm._s(_vm.$t("report.reports")))])]),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "v-btn",
                { staticClass: "accent", attrs: { to: "/report/new" } },
                [_vm._v(_vm._s(_vm.$t("report.newDialog.openDialogButton")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.reportList,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          "sort-by": _vm.pagination.sortBy,
          "sort-desc": _vm.pagination.descending
        },
        on: {
          "update:sortBy": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sort-by": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sortDesc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sort-desc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.created_at))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.reportTypeNames.find(function(v) {
                          return v.value === props.item.params.report_type
                        }).text
                      )
                    )
                  ]),
                  _c("td", [_vm._v(_vm._s(props.item.created_by_name))]),
                  _c(
                    "td",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadReport(
                                                props.item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("cloud_download")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                          )
                        ]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeReport(
                                                props.item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("global.removeFile")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }